import { SUBMISSION_GUIDE_URL } from 'features/pages/slice';
import { tv } from 'tailwind-variants';

import useFetchInfinite from 'lib/hooks/useFetchInfinite';

import {
  Bubble,
  Heading,
  Icon,
  LinkWithButtonStyles,
  Loader,
} from '@frontendmentorio/design-system-v2';

import SolutionCard from './Card';

const styles = tv({
  slots: {
    lockedCard: [
      'bg-gray-100',
      'flex-col',
      'gap-5',
      'items-center',
      'hidden',
      'mt-4',
      'pb-7',
      'pt-8',
      'px-5',
      'relative',
      'rounded-lg',
      'text-center',
      'w-full',
    ],
    solutionsWrapper: [
      'gap-5',
      'grid-cols-1',
      'hidden',
      'w-full',
      'tablet:grid-cols-2',
      'desktop:grid-cols-3',
    ],
  },
  variants: {
    isActive: {
      true: {
        lockedCard: 'flex',
        solutionsWrapper: 'grid',
      },
    },
  },
});

export default function Submitted({ challenge, isActive }) {
  const {
    data: { data: attempts, meta },
    isLoading,
    setPage,
  } = useFetchInfinite(
    `/api/v3/learner/solutions?filter=challenge|${challenge.id}`
  );

  const { lockedCard, solutionsWrapper } = styles({ isActive });

  if (isLoading && !attempts) return <Loader className="py-6" />;

  if (attempts?.length > 0) {
    return (
      <div className="flex flex-col gap-6 w-full">
        <ul className={solutionsWrapper()}>
          {attempts.map((solution) => (
            <SolutionCard key={solution.id} solution={solution} />
          ))}
        </ul>

        {meta?.page.next && (
          <LoadMore
            isLoading={isLoading}
            onClick={() => setPage(meta.page.next)}
          />
        )}
      </div>
    );
  }

  return (
    <div className={lockedCard()} data-testid="locked-card">
      <Bubble className="absolute-center-x bg-neutral-200 top-[-2rem]">
        <Icon className="text-xl" name="square-terminal" />
      </Bubble>

      <Heading level="4">No solutions submitted yet</Heading>

      <p className="max-w-prose">
        Not sure how to submit? Read our{' '}
        <a className="underline hover:no-underline" href={SUBMISSION_GUIDE_URL}>
          complete guide to submitting solutions
        </a>
      </p>

      <LinkWithButtonStyles href={`/challenges/${challenge.slug}?tab=submit`}>
        Submit solution
      </LinkWithButtonStyles>
    </div>
  );
}
